"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../utils/validations");
function updateQuizModuleMarksTotal({ marksTotal: existingMarksTotal }, { marksTotal }) {
    if (!(0, validations_1.isNumber)(existingMarksTotal)) {
        return marksTotal;
    }
    return Math.max(marksTotal, existingMarksTotal);
}
exports.default = updateQuizModuleMarksTotal;
